import { Button, BUTTON_VARIANTS } from 'ui/button';
import { Modal, ModalBody, ModalFooter, ModalHeader } from './';
import { ConfirmModalProps, ConfirmModalWithChildrenProps } from './types';
import { MODAL_SIZES } from './Modal.constants';

/** ConfirmModal
 * This modal is an abstraction that can be used in places where the user just needs to confirm an action.
 *
 * There are two options on how to use this modal.
 *
 * The first is a version that provides the user with a confirm/no confirm choice,
 * and requires requisite props for the confirm button to be passed in. Those props
 * are found in ConfirmModalProps.
 *
 * The second is version that allows for N number of actions by passing in child components instead.
 */
export const ConfirmModal = ({
  bodyContent,
  cancelLabel = 'Cancel',
  hasCancel = true,
  headerContent,
  id,
  isModalOpen,
  onClose,
  size = MODAL_SIZES.SMALL,
  style,
  variant,
  withPortal,
  ...props
}: ConfirmModalProps | ConfirmModalWithChildrenProps) => {
  return (
    <Modal
      id={id}
      isModalOpen={isModalOpen}
      onClose={onClose}
      size={size}
      style={style}
      variant={variant}
      withPortal={withPortal}
    >
      <ModalHeader>{headerContent}</ModalHeader>
      <ModalBody>{bodyContent}</ModalBody>
      <ModalFooter hasCancel={hasCancel} cancelLabel={cancelLabel} onClose={onClose}>
        {'children' in props ? (
          props.children
        ) : (
          <Button
            onClick={props.onConfirm}
            variant={props.confirmButtonVariant || BUTTON_VARIANTS.PRIMARY}
          >
            {props.confirmButtonContent}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};
